export default __webpack_public_path__ + "static/media/710.7f523cda.gif";